/* eslint jsx-a11y/anchor-is-valid: 0 */
/* eslint react/jsx-no-target-blank: 0 */

import { useState, useEffect } from "react"
import queryString from 'query-string'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import Button from 'react-bootstrap-button-loader'
import Autosuggest from 'react-autosuggest'
import moment from 'moment'
import { Container, Row, Col } from 'react-bootstrap'
import Spinner from '../Components/Spinner'
import * as constant from '../constant'
import * as ajax from '../Utilities/ajax'
import Auth from "../Utilities/Auth"
import { getUrlQueries } from "../Utilities/url"
import { useHistory } from "react-router-dom"

const suggestionData = [
  { title: 'Tag', list: [] },
  { title: 'BBG Code', list: [] },
  { title: 'Company Name', list: [] },
  { title: 'Sector', list: [] },
  { title: 'Author', list: [] },
  { title: 'Rating', list: constant.RECO },
  { title: 'Report Title', list: [] },
  { title: 'Report Type', list: [] },
]

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = value => {
  const escapedValue = escapeRegexCharacters(value.trim())

  if (escapedValue === '')
    return []

  // const regex = new RegExp('^' + escapedValue, 'i')
  const regex = new RegExp(escapedValue, 'i')

  return suggestionData
    .map(section => {
      return {
        title: section.title,
        list: section.list.filter(item => regex.test(item.value)).filter((_, i) => i < 10)
      }
    })
    .filter(section => section.list.length > 0)
}

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.value

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => <span>{suggestion.value}</span>
const renderSectionTitle = section => <strong>{section.title}</strong>
const getSectionSuggestions = section => section.list

const HEADER_LABEL = "Equity Research - FSSIA Publications"

export default function Publication({ location }) {
  const history = useHistory()

  const [Loading, setLoading] = useState(false)
  const [label, setLabel] = useState(HEADER_LABEL)
  const [value, setValue] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [datas, setDatas] = useState([])
  const [columns, setColumns] = useState([{ dataField: "dummy", text: "" }])

  const onSuggestionsFetchRequested = ({ value }) => setSuggestions(getSuggestions(value))
  const onSuggestionsClearRequested = () => setSuggestions([])

  const handleSelectedSuggestion = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }, records = datas) => {
    const searchKey = (suggestion.value || "").toLowerCase()
    let _datas

    // specific stock code is selected
    if (suggestionData[1].list.some(x => x.value?.toLowerCase() === searchKey)) {
      _datas = records.filter(x => x.stockCode?.toLowerCase() === searchKey)
    }
    // other search and specific report
    else {
      _datas = records.filter(x =>
        (x.analystName || "").toLowerCase().includes(searchKey)
        || (x.headline || "").toLowerCase().includes(searchKey)
        || (x.companyName || "").toLowerCase().includes(searchKey)
        || (x.stockCode || "").toLowerCase().includes(searchKey)
        || (x.reco || "").toLowerCase().includes(searchKey)
        || (x.sector || "").toLowerCase().includes(searchKey)
        || (x.tags || "").toLowerCase().includes(searchKey)
        || (x.reportType || "").toLowerCase().includes(searchKey)
        || ( // specific report is selected
          (x.companyName && x.stockCode)
          && ((`${x.companyName} (${x.stockCode}) - ${x.headline}`).toLowerCase() === searchKey)
        )
      )
    }

    setLabel(suggestion.value)
    setValue(suggestion.value)
    setColumns([])
    setDatas(_datas)
    genColumns()
    history.push(`/publication?q=${suggestion.value}`)
  }

  const handleDetectView = async (v) => {
    return await ajax.post("/report/library/view", { username: Auth.getUserName(), libraryId: v.id })
  }

  const genColumns = () => {
    const _columns = [
      // Date
      {
        dataField: 'reportDate',
        text: 'Date',
        headerStyle: { width: '100px' },
        style: { backgroundColor: 'white' },
        formatter: (c, r, i) => moment(c).format(constant.DATE_FORMAT),
      },
      // Title
      {
        dataField: 'headline',
        text: 'Title',
        headerStyle: { width: '480px' },
        style: { backgroundColor: 'white' },
        formatter: (c, r, i) => {
          if (r.category === "x") {
            return (
              <a
                style={{ 'color': 'rgb(0,0,0)' }}
                target='_blank'
                onClick={() => handleDetectView(r)}
                href={`${constant.BASE_URL}/download/pdf/${r.id}?extpub=1`}
              >
                {c}
              </a >
            )
          }

          let pdfName = r.pdfName ? r.pdfName : ""
          let fileNameWithType = pdfName.split(".")
          if (fileNameWithType.length !== 2) return c
          let fileNameWithOutType = fileNameWithType[0]

          return (
            <a
              style={{ 'color': 'rgb(0,0,0)' }}
              target='_blank'
              onClick={() => handleDetectView(r)}
              href={`${constant.BASE_URL}/download/pdf/${fileNameWithOutType}`}
            >
              {(r.companyName && r.stockCode) ? `${r.companyName} (${r.stockCode}) - ${c}` : c}
            </a>
          )
        },
      },

      // Recommendation
      {
        dataField: 'reco',
        text: 'Rating',
        headerStyle: { width: '120px' },
        style: { backgroundColor: 'white' },
      },
      // Target (THB)
      {
        dataField: 'targetPrice',
        text: 'Target (THB)',
        headerStyle: { width: '110px' },
        style: { backgroundColor: 'white' },
        // formatter: (c, r) => (r.reportType || "").toLowerCase().trim() === "sector report" ? "" : parseFloat(c || "0").toFixed(2),
        formatter: (c, r) => (c || "").trim() ? parseFloat(c || "0").toFixed(2) : "",
      },
      // Author
      {
        dataField: 'analystName',
        text: 'Author',
        headerStyle: { width: '224px' },
        style: { backgroundColor: 'white' },
      },
      // Sector
      {
        dataField: 'sector',
        text: 'Sector',
        headerStyle: { width: '180px' },
        style: { backgroundColor: 'white' },
      },
      // Report Type
      {
        dataField: 'reportType',
        text: 'Report Type',
        formatter: c => (c || "").toLowerCase().trim() === "sector freestyle" ? "Sector Report" : c,
        headerStyle: { width: '140px' },
        style: { backgroundColor: 'white' },
      }
    ]
    setColumns(_columns)
  }

  const reload = async () => {
    setLoading(true)

    let results = []

    await ajax.get("/list").then(result => {
      suggestionData[0].list = (result.data || {}).tags || []
      suggestionData[1].list = (result.data || {}).companiesCode || []
      suggestionData[2].list = (result.data || {}).companiesName || []
      suggestionData[3].list = (result.data || {}).sectors || []
      suggestionData[4].list = (result.data || {}).analysts || []
      suggestionData[6].list = (result.data || {}).headlines || []
      suggestionData[7].list = (result.data || {}).reportType || []

      results = (result.data || {}).reports
      setDatas(results)

      const qStr = queryString.parse(location.search)
      const searchKey = qStr.search
      if (searchKey) { handleForcedSuggestion(searchKey) }
    }).catch(e => {
      console.log(e)
      alert("Error, please try again [6]")
    })

    setLoading(false)

    return results
  }

  const handleForcedSuggestion = (searchKeyFromQstr) => {
    const searchKey = searchKeyFromQstr.toLowerCase()
    const _datas = datas.filter(d =>
      (d.analystName || "").toLowerCase().includes(searchKey)
      || (d.headline || "").toLowerCase().includes(searchKey)
      || (d.companyName || "").toLowerCase().includes(searchKey)
      || (d.stockCode || "").toLowerCase().includes(searchKey)
      || (d.reco || "").toLowerCase().includes(searchKey)
      || (d.sector || "").toLowerCase().includes(searchKey)
    )
    setLabel(searchKeyFromQstr)
    setValue(searchKeyFromQstr)
    setColumns([])
    setDatas(_datas)
    genColumns()
  }

  const handleBack = () => {
    window.location.href = '/publication'
  }

  useEffect(() => {
    new Promise(async (r) => {
      genColumns()
      const results = await reload()

      const queries = getUrlQueries()
      if (queries.q) {
        handleSelectedSuggestion(undefined, { suggestion: { value: queries.q } } as any, results)
      }

      r(true)
    })

    // eslint-disable-next-line
  }, [])

  const inputProps = {
    placeholder: 'Filter by report title, author, company name, BBG code, recommendation, sector, report type',
    value,
    onChange: (_, { newValue }) => setValue(newValue),
    disabled: label !== HEADER_LABEL,
  }

  return (
    <Container fluid className="container-publication elib" style={{ marginTop: -15, minHeight: "calc(100vh - 145px)" }}>
      {/* <Report Title> */}
      <Row>
        <Col>
          <p style={{ paddingTop: 10, fontFamily: "Arial Narrow, Arial, sans-serif", fontSize: 20.8, fontWeight: "bolder", marginBottom: 6 }}>{label}</p>
        </Col>
      </Row>

      {/* Back to all reports */}
      <Row>
        <Col>
          {label !== HEADER_LABEL &&
            <div style={{ textAlign: "left", paddingBottom: 10 }}>
              <Button variant="outline-secondary" onClick={handleBack}>{"Back to all reports"}</Button>
            </div>
          }
        </Col>
      </Row>

      {/* Auto Suggestion */}
      <Row>
        <Col>
          <Autosuggest
            multiSection={true}
            suggestions={suggestions}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            renderSectionTitle={renderSectionTitle}
            getSectionSuggestions={getSectionSuggestions}
            inputProps={inputProps}
            onSuggestionSelected={handleSelectedSuggestion}
          />
        </Col>
      </Row>

      {/* Bootstrap Table */}
      <Row style={{ marginTop: 10 }}>
        <Col>
          {Loading && <Spinner />}
          {!Loading &&
            <BootstrapTable keyField='id'
              id="Publication"
              wrapperClasses="table-responsive"
              bootstrap4
              data={datas}
              columns={columns}
              pagination={paginationFactory({
                hidePageListOnlyOnePage: true,
                sizePerPage: 15,
                sizePerPageList: [15, 50, 100],
                hideSizePerPage: false,
              })}
            />
          }
        </Col>
      </Row>
    </Container>
  )
}
